import * as React from 'react'
import { HelpCircle } from 'react-feather'
import { styled } from '@mui/material/styles'
import theme from '../../theme/theme'

type HelpFaqCardProps = {
	url?: string
}

const Support = styled('a')`
	background-color: ${theme.palette.secondary.main};
	position: fixed;
	bottom: 20px;
	right: 20px;
	color: white;
	padding: 0px 10px;
	border-radius: 50%;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
	cursor: pointer;
	width: 20px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: start;
	transition: all 0.3s;

	span {
		display: none;
		opacity: 0;
		transition: opacity 0.3s;
		margin-left: 10px;
	}

	:hover {
		width: 100px;
		border-radius: 15px;

		span {
			display: block;
			opacity: 1;
		}
	}
`

export default function HelpFaqCard({ url }: HelpFaqCardProps) {
	const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault()
		window.open(url, '_blank', 'noopener,noreferrer')
	}

	return (
		<Support className="support-button" href={url} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
			<HelpCircle />
			<span>Help</span>
		</Support>
	)
}
